import React from 'react';

const YuhoBlowingKisses = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>((props, ref) => (
  <svg viewBox="0 0 1080 720" {...props} ref={ref}>
    <ellipse cx={538.34} cy={664.15} rx={116.49} ry={39.62} fill="#e3e3e3" />
    <path
      d="M473.82 530.73c-30.07-1.64-62.68-19.48-82.42-38.16-19.74-18.68-26.45-48.08-14.93-65.53 11.53-17.46 33.57-22.5 47.69-13.2 14.12 9.3 33.01 23.44 47.02 41.15 14.78 18.7 20.42 49.06 19.93 55.79-.49 6.72 2.08 21.01-17.3 19.95Z"
      fill="#02b4e2"
    />
    <path
      d="M399.64 499.71c18.35-22.28 35.46-58.42 32.14-80.39-2.61-2.03-5.17-3.87-7.61-5.48-14.12-9.3-36.17-4.26-47.69 13.2-11.53 17.46-4.81 46.85 14.93 65.53 2.54 2.41 5.3 4.8 8.24 7.15Z"
      fill="#def6fd"
    />
    <path
      d="M669.94 224.09c22.18-23.92 62.63-47.09 74.18-35.68 13.46 13.3-3.39 73.45-45.07 95.77-48.91 26.2-45.07-42.88-29.11-60.09Z"
      fill="#00c2e8"
    />
    <path
      d="M682.2 212.47c-4.44 3.75-8.6 7.67-12.26 11.62-15.96 17.21-19.8 86.29 29.11 60.09 15.42-8.26 27.42-21.69 35.77-36.01-9.89-20.45-32.6-33.89-52.61-35.7Z"
      fill="#02b4e2"
    />
    <path
      d="M681.52 236.45c14.84-18.56 49.08-43.53 54.51-35.16 5.22 8.03-9.7 51.17-41 70.26-12.28 7.49-11.95 4.17-16.02.73s.31-16.59-.63-20.34c-.94-3.76-1.88-9.23 3.13-15.49Z"
      fill="#fff"
    />
    <path
      d="M700.96 217.31c-7.44 6.12-14.51 12.99-19.44 19.15-5.01 6.26-4.07 11.74-3.13 15.49.94 3.76-3.44 16.9.63 20.34 4.07 3.44 3.74 6.76 16.02-.73 14.16-8.64 24.96-22.2 32.07-35.21-7.05-8.4-16.35-14.92-26.14-19.05Z"
      fill="#d9f8ff"
    />
    <path
      d="M486.85 193.42c-11.07-18.08-42.25-50.7-55.71-37.56-13.46 13.15-6.57 50.08 12.83 77.93 19.4 27.85 52.27-25.04 42.88-40.37Z"
      fill="#00c2e8"
    />
    <path
      d="M486.85 193.42a90.863 90.863 0 0 0-4.22-6.24c-19.01 4.24-37.93 16.45-48.48 29.61 2.77 5.85 6.05 11.6 9.82 17.01 19.4 27.85 52.27-25.04 42.88-40.37Z"
      fill="#02b4e2"
    />
    <path
      d="M451.48 226.75c-16.1-22.53-22.53-52.58-15.96-58.53 6.09-5.51 23.79 10.64 38.5 36.93s-13.15 34.74-22.53 21.6Z"
      fill="#fff"
    />
    <path
      d="M451.48 226.75c9.39 13.14 37.24 4.69 22.53-21.6-2.5-4.47-5.08-8.63-7.68-12.46-9.35 4.23-18.04 10.01-24.98 16.41 2.75 6.02 6.14 12.06 10.12 17.64Z"
      fill="#d9f8ff"
    />
    <path
      d="M534.87 46.84c.47 32.16-1.64 61.03-4.69 85.68-2.83 22.87-13.43 51.41-26.21 51.41-6.57 0-13.34-1.98-14.45-16.02-1.35-17.08 2.45-37.06 4.56-55.61 1.26-11.08 5.59-18.05 12.39-18.05 4.23-14.79 5.63-33.33 7.51-46.95 2.15-15.57 20.68-15.05 20.89-.47Z"
      fill="#def6fd"
    />
    <path
      d="M494 113c-.33 2.97-.63 5.96-.91 8.96 1 6.82-.12 16.4 1.49 21.6 2.82 9.08 11.72 9.55 11.89.16.31-16.74-1.72-30.71-12.47-30.71Zm14.45-26.83-1.99 8.08c6.34 0 9.68 3.8 10.81 11.74 1.15 8.1 1.39 20.03 1.16 24.18 4.77-30.59 1.33-44-9.98-44Z"
      fill="#c5edfb"
    />
    <path
      d="M484.16 135.99c.16-5.98 2.06-16.41 10.09-16.41 6.73 0 10.02 6.91 11.58 18.49.77 5.69 1.88 16.9 5.95 21.28 8.32 8.96-3.4 24.57-7.82 24.57-7.82 0-13.52-4.78-16.59-15.34-2.5-8.61-3.52-20.97-3.21-32.6Z"
      fill="#def6fd"
    />
    <path
      d="M462.43 568.05c1.82 34.58 5.63 58.21 10.64 72.61 5.01 14.4 15.02 29.11 35.21 29.11 18.31 0 26.13-10.33 27.39-24.73 1.22-14.04.63-20.03-.63-40.69-1.25-20.66-73.86-60.09-72.61-36.31Z"
      fill="#00c2e8"
    />
    <path
      d="M501.47 669.16c2.13.4 4.4.61 6.82.61 18.31 0 26.13-10.33 27.39-24.73 1.22-14.04.63-20.03-.63-40.69l-19.19 21.81c2.64 17.61 1.98 38.53-14.38 42.99Z"
      fill="#02b4e2"
    />
    <path
      d="M534.91 650.11c-23.26.04-45.2.56-61.42-8.29 5.14 14.02 15.15 27.95 34.79 27.95 16.08 0 24.07-7.97 26.62-19.66Z"
      fill="#def6fd"
    />
    <path
      d="M452.94 552.21c0 44.37 14.08 83.81 63.85 83.81 55.8 0 86.48-24.15 88.36-79.24 1.88-55.08 3.76-89.51-10.02-108.92-13.77-19.4-107.04-30.05-116.43-6.89-3.09 7.63-8.57 16.45-11.89 26.92-7.77 24.47-13.87 57.46-13.87 84.32Z"
      fill="#00c2e8"
    />
    <ellipse cx={518.43} cy={552.21} rx={51.88} ry={75.66} fill="#fff" />
    <path
      d="M543.04 623.9c.69 4.93 1.43 9.64 2.23 14.42 2.96 17.84 12.35 31.45 33.58 31.45 19.26 0 27.51-11.48 28.8-24.73 1.62-16.53.16-50.86-3.6-86.54-.88-8.32-12.07-12.5-25.02-12.95-1.5 57.05-11.3 72.2-36 78.34Z"
      fill="#00c2e8"
    />
    <path
      d="M563.71 666.74c4.21 1.93 9.19 3.03 15.14 3.03 19.26 0 27.51-11.48 28.8-24.73 1.62-16.53.16-50.86-3.6-86.54-.39-3.73-2.86-6.62-6.63-8.72-.93 1.99-1.55 4.55-1.3 7.84 5.16 66.66 1.41 102.34-32.42 109.12Z"
      fill="#02b4e2"
    />
    <path
      d="M607.66 645.04c.31-3.12.5-6.87.59-11.13-20.68 15.98-40.91 16.64-59.54 16.66 4.86 11.45 14.13 19.2 30.14 19.2 19.26 0 27.51-11.48 28.8-24.73Z"
      fill="#def6fd"
    />
    <path
      d="M571.98 170.57c-64.81-6.17-117.68 38.18-142.72 84.5-25.04 46.32-28.37 85.62-21.28 118.93 6.26 29.42 20.66 46.95 38.18 57.59 15.08 9.15 23.84 23.37 20.66 36.31-3.47 14.1 48.11 1.38 62.5-1.75 14.4-3.13 67.07 9.89 72.08-.75 5.01-10.64 11.89-13.15 26.29-15.65 14.4-2.5 37.3-10.12 52.32-33.28 19.34-29.81 25.92-78.77 20.29-124.46-5.63-45.69-36.31-112.67-128.32-121.43Z"
      fill="#00c2e8"
    />
    <path
      d="M474.54 217.63c-10.74-.95-22.37 7.13-32.68 17.61-4.74 6.48-8.97 13.13-12.59 19.84-9.57 17.7-15.96 34.37-19.81 50.08 2.94 6.94 10.75 12.52 19.33 12.52 24.33 0 47.18-15.75 60.63-51.82 9.91-26.59.45-46.87-14.87-48.22Z"
      fill="#fff"
    />
    <path
      d="M571.98 170.57c-16.24-1.55-31.73.08-46.22 4.12 51.59-1.09 81.32 2.89 117.32 38.35 41.94 41.31 43.7 108.3 35.68 147.41-7.51 36.62-23.16 59.78-46.32 66.66-24.36 7.24-39.43 16.9-41.31 35.68-.88 8.79 1.53 10.03 5.95 8.62 2.05-2.33 3.56-4.39 4.33-6.01 5.01-10.64 11.89-13.15 26.29-15.65 14.4-2.5 37.3-10.12 52.32-33.28 19.34-29.81 25.92-78.77 20.29-124.46-5.63-45.69-36.31-112.67-128.32-121.43Z"
      fill="#02b4e2"
    />
    <path
      d="M618.33 181.46c-13.38-5.39-28.74-9.21-46.36-10.88-16.24-1.55-31.73.08-46.22 4.12-3.49 16.61-.89 43.55 18.2 44.4 20.23.9 50.84-26.88 74.37-37.63Zm55.42 102.61c0 34.11-25.12 61.76-56.11 61.76s-56.11-27.65-56.11-61.76 25.12-61.76 56.11-61.76 56.11 27.65 56.11 61.76Z"
      fill="#fff"
    />
    <path
      d="M607.87 186.97c3.6-2.1 7.1-3.98 10.46-5.52-1.65-.67-3.34-1.31-5.05-1.92-.05-.02-.1-.03-.14-.05-1.7-.61-3.42-1.19-5.18-1.75-.01 0-.02 0-.03-.01-1.73-.55-3.48-1.07-5.27-1.57l-.55-.15c-1.71-.47-3.44-.92-5.21-1.34-.06-.02-.13-.03-.19-.05-1.77-.42-3.58-.81-5.41-1.19-.33-.07-.66-.13-.99-.2-1.74-.34-3.51-.67-5.3-.97-.09-.02-.18-.03-.28-.05-1.84-.3-3.71-.57-5.6-.82-.44-.06-.89-.12-1.33-.17-1.91-.24-3.83-.46-5.8-.65-1.01-.1-2.02-.14-3.03-.22-1.06-.08-2.12-.17-3.18-.22-13.99-.65-27.38 1.03-40.01 4.55 34.27-.72 58.89.8 82.11 12.29Z"
      fill="#d9f8ff"
    />
    <path
      d="M512.79 301.43c55.98 3.18 64.7 56.45 63.02 86.07-1.63 28.75-28.95 50.81-70.65 48.45-41.7-2.37-66.35-27.38-64.72-56.13 1.68-29.62 16.37-81.57 72.35-78.39Z"
      fill="#fff"
    />
    <path
      d="M507.57 362.26c21.67 1.23 43.89-12.4 44.74-27.4.66-11.72-13.05-20.18-41.95-21.82-28.9-1.64-43.48 5.21-44.15 16.93-.85 15 19.68 31.05 41.36 32.28Zm98.21 101.26c28.15 10.68 53.83 37.56 66.98 61.34 13.15 23.79 10.64 53.83-5.63 66.98-16.27 13.15-38.81 11.27-49.45-1.88-10.64-13.15-24.36-32.34-32.34-53.47-8.42-22.3-4.59-52.95-2.09-59.21 1.18-2.95-1.12-17.55 3.26-17.55 4.93 0 9.66.14 19.27 3.78Z"
      fill="#00c2e8"
    />
    <path
      d="M635.91 481.38c15.57 17.33 20.93 35.24 21.56 56.52.72 24.53-23.65 49.71-42.9 48.02 1.04 1.41 2.08 2.77 3.1 4.04 10.64 13.14 33.18 15.02 49.45 1.88 16.27-13.14 18.78-43.19 5.63-66.98-8.21-14.85-21.31-30.91-36.84-43.48Z"
      fill="#02b4e2"
    />
    <path
      d="M667.07 515.55c-24.24 15.67-51.5 44.92-54.99 66.87 1.88 2.73 3.75 5.26 5.59 7.53 10.64 13.14 33.18 15.02 49.45 1.88 16.27-13.14 18.78-43.19 5.63-66.98-1.69-3.06-3.6-6.18-5.69-9.31Zm-53.5-385.62c-3.21 20.34-1.31 61.09 21.41 68.27 12.24 3.86 25.77-3.86 34.78-18.04 5.16 9.63 10.95 18.04 28.99 14.17 18.04-3.86 35.42-24.48 41.22-57.33 5.8-32.85-3.21-76.65-25.77-91.46-13.23-8.7-24.33 1.13-14.64 13.37 9.69 12.24 16.97 31.93 16.65 56.73-.3 22.87-5.15 40.26-20.67 47.76-5.15-6.42-5.79-27.05-5.79-37.35s-4.38-22.3-13.37-23.2c-9.63-.96-16.06 7.92-17.81 21.47-2.9 22.54-8.11 48.1-19.71 48.1-10.8 0-7.58-28.97-7.73-40.58-.13-12.56-15.11-17.38-17.56-1.93Z"
      fill="#def6fd"
    />
    <path
      d="M719.1 182.09c-7.43 7.18-20.16 10.14-29.34 9.2-9-.93-14.02-6.53-15.32-12.73-.47-2.25-1.78-2.6-2.72-1.07-.6.93-1.25 1.82-1.95 2.68 5.16 9.63 10.95 18.04 28.99 14.17 7.36-1.58 14.62-5.95 21.02-12.85-.24.22-.47.4-.69.6Z"
      fill="#c5edfb"
    />
    <path
      d="M669.6 111.38c-5.27 1.65-5.69 10.4-6.36 16.06-.71 6.01-2.72 18.97-4.13 24.98-1.41 6.02 1.54 8.72 5.66 2.47 5.89-8.96 8.71-21.33 9.43-30.06.5-6.21 1.06-15.22-4.6-13.46Zm33.59-53.03c5.74 8.2 13.5 21.41 16.26 38.89 2.25 14.25 1.77 30.77-1.07 40.3-2.84 9.54 2 9.44 5.89-1.3a85.233 85.233 0 0 0 4.28-39.71c-2.59-19.56-10.49-32.87-16.14-38.18s-11.69-3.53-9.22 0Z"
      fill="#fff"
    />
    <path
      d="M426.65 279.93c3.4-16.9 13.21-29.13 24.73-30.2 10.09-.94 17.37 4.77 19.4 21.87.52 4.35-4.45 5.72-5.87.12-2.35-9.27-6.57-13.97-13.54-13.38-8.06.68-14.51 7.12-19.33 22.77-1.23 4-6.4 3.78-5.4-1.17Zm213.77 18.23c-1.66-15.45-6.81-26.72-17.84-30.83-12.24-4.56-25.42.63-37.24 13.77-4.8 5.34-8.1.21-5.79-4.07 10.27-19.05 29.85-27.85 47.46-21.4 16.36 6 22.57 24.03 20.89 43.29-.43 4.86-6.77 5.76-7.47-.77Z"
      fill="#202125"
    />
    <path
      d="M285.29 97.93c-1.83-8.78-13.32-11.44-18.2.56-4.87-12-16.36-9.34-18.19-.56-1.88 9 8.25 18.76 18.19 27.95 9.91-9.19 20.08-18.94 18.2-27.95Z"
      fill="#009de0"
    />
    <path
      d="M355.35 204.57c-1.83-8.78-13.32-11.45-18.19.56-4.88-12-16.37-9.34-18.2-.56-1.88 9 8.25 18.76 18.2 28 9.94-9.24 20.07-19 18.19-28Zm-173.47 78.9c-1.83-8.78-13.32-11.44-18.2.57-4.88-12-16.37-9.35-18.2-.57-1.87 9 8.26 18.76 18.2 28 9.94-9.24 20.07-18.99 18.2-28Z"
      fill="#00c2e8"
    />
    <path
      d="M321.23 411c-1.83-8.78-13.32-11.45-18.2.56-4.88-12-16.37-9.34-18.2-.56-1.87 9 8.26 18.76 18.2 27.95 9.97-9.24 20.08-18.95 18.2-27.95Z"
      fill="#009de0"
    />
    <path
      d="M585.25 30.75c-1.83-8.78-13.32-11.44-18.2.57-4.87-12-16.37-9.35-18.19-.57-1.88 9 8.25 18.76 18.19 28 9.95-9.24 20.08-18.99 18.2-28ZM869.61 151c-1.83-8.77-13.32-11.44-18.2.57-4.88-12-16.37-9.34-18.2-.57-1.87 9 8.26 18.76 18.2 28 9.94-9.21 20.07-19 18.2-28Z"
      fill="#00c2e8"
    />
    <path
      d="M804.89 301.88c-1.83-8.78-13.32-11.45-18.2.56-4.87-12-16.36-9.34-18.19-.56-1.88 9 8.25 18.76 18.19 27.95 9.95-9.19 20.08-18.95 18.2-27.95Z"
      fill="#009de0"
    />
    <path
      d="M944.22 380.74c-1.83-8.78-13.32-11.45-18.2.56-4.88-12-16.37-9.34-18.2-.56-1.88 9 8.26 18.76 18.2 27.95 9.98-9.19 20.07-18.95 18.2-27.95Z"
      fill="#00c2e8"
    />
    <path
      d="M810.34 525.55c-1.83-8.78-13.32-11.45-18.2.56-4.88-12-16.37-9.34-18.2-.56-1.87 9 8.26 18.76 18.2 28 9.94-9.24 20.07-19 18.2-28Z"
      fill="#009de0"
    />
  </svg>
));

export default YuhoBlowingKisses;
